import React, { useState, Fragment, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import SearchCard from "../../components/PropertySearchCard";
import SearchCardLoader from "../../components/SearchCardLoader";
import Typography from "@material-ui/core/Typography";
import { Alert, AlertTitle } from "@material-ui/lab";
import FilterComponent from "../../components/Filter";
import DropDownComponent from "../../components/DropDown";
import Pagination from "@material-ui/lab/Pagination";
import { useRouter } from "next/router";
import { NextSeo } from "next-seo";
import useTranslation from "next-translate/useTranslation";
import { mapQueryParams } from "../../../libs/queryParams";
import SearchBar from "../../components/SearchBar";
import { PROPERTY_SEARCH_PAGE, HOST } from "../../config/routes";
import { getPOI, getSelectedPOI } from "../../../store/actions/POI";
import { getSelectedProperties } from "../../../store/actions/Property";
import { POI_TYPE } from "../../config/constants";
import BrandConstants from "./../../../brands/constants";
import {
  title,
  description,
  generateAlternateLanguages,
} from "../../config/seo";
import useStyles from "./style";
import Image from "../../components/Image";
import { getProperties } from "../../../store/actions/Property";
import screenSize from "../../states/screen";
import { stubTrue } from "lodash";

function PropertySearchPageContainer({
  url,
  city,
  type,
  limit = 20,
  page = 1,
  sort = "nameAsc",
  poiId,
  propertyId,
  propertyType,
  bathroom,
  bedroom,
  minPrice,
  maxPrice,
  status,
  propertyData,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const router = useRouter();
  const { t } = useTranslation("common");
  const isDesktop = screenSize();
  const [filterValues, setFilterValues] = useState({
    city,
    type,
    limit,
    page,
    sort,
    poiId,
    propertyId,
    propertyType,
    bathroom,
    bedroom,
    minPrice,
    maxPrice,
    status,
    autocompleteData: [],
  });
  const [appliedFilterCount, setAppliedFilterCount] = useState(0);

  const setFilterCount = ({
    city,
    sort,
    limit,
    page,
    autocompleteData,
    ...rest
  }) => {
    let count = 0;
    for (let i in rest) {
      if (rest[i]) {
        count += 1;
      }
    }
    setAppliedFilterCount(count);
  };

  const handleSortDropdownChange = (value) => {
    const newValues = {
      ...filterValues,
      sort: value,
    };
    setFilterValues(newValues);
    updateSearch(newValues);
  };

  const handleChangePage = (event, value) => {
    event.preventDefault();
    const newValues = {
      ...filterValues,
      page: parseInt(value, 10),
    };
    setFilterValues(newValues);
    updateSearch(newValues);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    updateSearch();
  };

  const updateSearch = (newValues) => {
    const filterParams = getQueryparams(newValues || filterValues);

    router.push(
      {
        pathname: router.route.replace("[city]", filterParams.city),
        query: { ...filterParams },
      },
      undefined,
      { shallow: true }
    );
  };

  useEffect(() => {
    const val = {
      ...filterValues,
      ...router.query,
    };

    if (!router.query.propertyId) {
      val.propertyId = [];
    }

    if (!router.query.poiId) {
      val.poiId = [];
    }

    setFilterCount(val);
    setFilterValues(val);
    if (router.query && router.query.city) {
      dispatch(getProperties(getQueryparams(val)));
    }
  }, [router.query]);

  const getQueryparams = (values) => {
    const { autocompleteData, ...others } = values;
    const filterParams = {
      ...others,
      poiId: [],
      propertyId: [],
    };

    if (autocompleteData && autocompleteData.length) {
      for (let i = 0; i < autocompleteData.length; i++) {
        let id = autocompleteData[i]._id;
        if (POI_TYPE.includes(autocompleteData[i].type)) {
          filterParams.poiId.push(id);
        } else {
          filterParams.propertyId.push(id);
        }
      }
    }

    const newFilterParams = {};
    for (let i in filterParams) {
      if (filterParams[i]) {
        newFilterParams[i] = filterParams[i];
      }
    }

    return newFilterParams;
  };

  useEffect(() => {
    if (poiId) {
      dispatch(getSelectedPOI(poiId));
    }
  }, [poiId]);

  useEffect(() => {
    if (propertyId) {
      dispatch(getSelectedProperties(propertyId));
    }
  }, [propertyId]);

  const PropertyReducer = useSelector((state) => {
    return state.PropertyReducer;
  });

  const selectedProperties = useSelector((state) => {
    return state.PropertyReducer.selectedProperties;
  });

  const listings =
    PropertyReducer &&
    PropertyReducer.properties &&
    PropertyReducer.properties.length
      ? PropertyReducer.properties
      : propertyData
      ? propertyData.properties
      : [];

  const isLoading = PropertyReducer.isLoading;
  const totalRecords = PropertyReducer.totalRecords
    ? PropertyReducer.totalRecords
    : propertyData
    ? propertyData.totalRecords
    : 0;

  let selectedSuggestions = useSelector(
    (state) => state.POIReducer.selectedSuggestions
  );

  useEffect(() => {
    setFilterValues({
      ...filterValues,
      autocompleteData: [...selectedProperties, ...selectedSuggestions],
    });
  }, [selectedSuggestions, selectedProperties]);

  const propertyTypeLabel =
    BrandConstants.PROPERTY_TYPES.find(
      (propertyTypes) => propertyTypes.code === propertyType
    ) || {};

  const pageTitle = t(
    title[city] && title[city][propertyType.toLowerCase()]
      ? title[city][propertyType.toLowerCase()]
      : title.home
  );
  const pageDescription = t(
    description[city] && description[city][propertyType.toLowerCase()]
      ? description[city][propertyType.toLowerCase()]
      : description.home
  );

  return (
    <Fragment>
      {isDesktop ? (
        <Box my={1} p={3} className={classes.searchRoot} disableGutters={true}>
          <Container
            maxWidth="md"
            style={{ paddingTop: "10px", paddingBottom: "10px" }}
          >
            <form onSubmit={handleFormSubmit}>
              <FilterComponent
                filterValues={filterValues}
                setFilterValues={setFilterValues}
                hidePriceAndBedroom={true}
                hideListingType={true}
                hidePropertyType={true}
                showCity={false}
                showPropertyStatus={true}
                showCountryDistrict={true}
              />
            </form>
          </Container>
        </Box>
      ) : null}
      <Container
        maxWidth="md"
        className={isDesktop ? null : classes.pageSection}
      >
        <Grid container xs={12}>
          <Grid container xs={12} lg={9}>
            <Grid container xs={12}>
              {!isLoading ? (
                <Fragment>
                  <NextSeo
                    title={pageTitle}
                    description={pageDescription}
                    languageAlternates={generateAlternateLanguages(url)}
                  />
                  <Grid container xs={12} sm={8}>
                    <Grid container xs={12}>
                      <Typography
                        className={classes.heading}
                        variant="h5"
                        component="h1"
                      >
                        {city} {propertyTypeLabel.label}
                      </Typography>
                    </Grid>
                    <Grid container xs={12}>
                      <Typography
                        gutterBottom
                        variant="subtitle1"
                        component="h3"
                      >
                        {totalRecords} {propertyTypeLabel.label}
                        {totalRecords > 1 ? "s" : ""} available on
                        PropertyGlassdoor
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container xs={6} sm={4}>
                    <DropDownComponent
                      value={sort}
                      name="sort-dropdown"
                      hideTopLabel={true}
                      label="Sort"
                      fullWidth
                      options={[
                        { code: "nameAsc", label: "Sort: Name ASC" },
                        { code: "nameDesc", label: "Sort: Name Desc" },
                      ]}
                      onChange={handleSortDropdownChange}
                    />
                  </Grid>
                  {!isDesktop ? (
                    <Grid container xs={6}>
                      <FilterComponent
                        appliedfilterCount={appliedFilterCount}
                        filterValues={filterValues}
                        setFilterValues={setFilterValues}
                        applyFilter={handleFormSubmit}
                        hidePriceAndBedroom={true}
                        hideListingType={true}
                        hidePropertyType={true}
                        showCity={false}
                        showPropertyStatus={true}
                        showCountryDistrict={true}
                      />
                    </Grid>
                  ) : null}
                </Fragment>
              ) : null}
            </Grid>

            {!isLoading ? (
              <Fragment>
                <Grid
                  container
                  direction="row"
                  justify="space-between"
                  alignItems="flex-start"
                  xs={12}
                  sm={12}
                >
                  {listings && listings.length ? (
                    listings.map((listing) => (
                      <Grid item xs={12}>
                        <SearchCard
                          favourites={PropertyReducer.favourites}
                          {...listing}
                        />
                      </Grid>
                    ))
                  ) : (
                    <div className={classes.errorMessage}>
                      <Alert severity="error" fullWidth>
                        <AlertTitle>Error</AlertTitle>
                        No Record Found — <strong>Please update filter!</strong>
                      </Alert>
                    </div>
                  )}
                </Grid>
                <Grid container justify="center" xs={12} alignItems="center">
                  <div className={classes.paginationRoot}>
                    <Pagination
                      page={Number(page)}
                      count={Math.ceil(totalRecords / limit)}
                      onChange={handleChangePage}
                      variant="outlined"
                      shape="rounded"
                    />
                  </div>
                </Grid>
              </Fragment>
            ) : (
              <SearchCardLoader item={limit} />
            )}
          </Grid>
          {/* <Grid container xs={12} sm={3} justify="center">
            <Image
              width="250"
              height="500"
              src="/images/right-banner-image.jpg"
            />
          </Grid> */}
        </Grid>
      </Container>
    </Fragment>
  );
}

export default PropertySearchPageContainer;
